import React, {useEffect, useState} from 'react';
import './index.scss';
import CustomSelect from '../CustomSelect';
import Input from '../Input';
import Checkbox from '../Checkbox';
import {
  useGetAgencyQuery,
  useLazyGetFacilityByAgencyQuery,
} from '../../store/builder/inspections.api';
import {useDispatch, useSelector} from 'react-redux';
import {setLoader} from '../../store/builder/reducer';
import CustomPaginate from '../PaginateComponent';
import FacilityModal from '../FacilityModal';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from '../../hooks/useTranslation';

const ProfileFacility = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);
  const [currentPage, setCurrentPage] = useState(1);
  const [warning, setWarning] = useState(false);
  const [createFacilityStatus, setCreateFacilityStatus] = useState(false);

  const [
    getFacilityByAgencyId,
    {
      data: getFacilityByAgencyIdIdData,
      error: getFacilityByAgencyIdError,
      isLoading: getFacilityByAgencyIdIsLoading,
      isSuccess: getFacilityByAgencyIdIsSuccess,
      isError: getFacilityByAgencyIdIsError,
    },
  ] = useLazyGetFacilityByAgencyQuery();

  const {data, isLoading, isSuccess, isError} = useGetAgencyQuery();

  useEffect(() => {
    getFacilityByAgencyId({id: userInfo?.agency?.id, page: currentPage});
  }, [currentPage]);

  const getFacility = () => {
    getFacilityByAgencyId({id: userInfo?.agency?.id, page: currentPage});
  };

  useEffect(() => {
    dispatch(setLoader(getFacilityByAgencyIdIsLoading));
  }, [getFacilityByAgencyIdIsLoading]);

  const handlePageClick = page => {
    setCurrentPage(page.selected + 1);
    window.scrollTo(0, 0);
  };

  return (
    <div>
      {createFacilityStatus && (
        <FacilityModal
          setModal={setCreateFacilityStatus}
          getData={getFacility}
        />
      )}
      {warning && (
        <div className='modal'>
          <div className='modal__content'>
            <div className='modal__content-head'>
              <p>{t('profileFacility.modals.warning.title')}</p>
            </div>
            <div className='modal__content-body'>
              <p style={{lineHeight: '24px', fontSize: 16}}>
                {t('profileFacility.modals.warning.message')}
              </p>
            </div>
            <div className='modal__content-bottom'>
              <button className='close' onClick={() => setWarning(false)}>
                {t('actions.close')}
              </button>
              <button className='save' onClick={() => setWarning(false)}>
                {t('actions.ok')}
              </button>
            </div>
          </div>
          <div className='modal__bg'></div>
        </div>
      )}
      <div className='profile__info'>
        <p className='profile__title'>{t('profileFacility.title')}</p>
        <button
          className='profile__info-btn'
          onClick={() => {
            if (data[0]?.is_able_to_add_facility_trial) {
              setCreateFacilityStatus(true);
            } else {
              setWarning(true);
            }
          }}
        >
          {t('profileFacility.buttons.createFacility')}
        </button>
      </div>
      <div className='profile__table'>
        <div className='profile__table-head'>
          <div className='profile__table-th'>{t('profileFacility.tableHeaders.facilityName')}</div>
          <div className='profile__table-th'>{t('profileFacility.tableHeaders.totalInspections')}</div>
          <div className='profile__table-th'>{t('profileFacility.tableHeaders.inspectionsEnabled')}</div>
          <div className='profile__table-th'></div>
        </div>
        <div className='profile__table-body'>
          {getFacilityByAgencyIdIdData?.data?.length ? (
            getFacilityByAgencyIdIdData?.data?.map(item => (
              <div className='profile__table-row' key={item?.id}>
                <div className='profile__table-bodyTh'>{item?.name}</div>
                <div className='profile__table-bodyTh'>
                  {item?.links?.length}
                </div>
                <div className='profile__table-bodyTh'>
                  {item?.inspections_enabled ? t('profileFacility.status.enabled') : t('profileFacility.status.notEnabled')}
                </div>
                <div className='profile__table-bodyTh'>
                  <div onClick={() => navigate('/facility/edit/' + item.id)}>
                    {t('profileFacility.buttons.edit')}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className='facility__table-empty'>
              <img src='/assets/icons/facility-empty.svg' alt='empty' />
              <p>{t('profileFacility.messages.noFacilities')}</p>
            </div>
          )}
        </div>
      </div>
      <CustomPaginate
        pageCount={getFacilityByAgencyIdIdData?.pages}
        handlePageClick={handlePageClick}
      />
    </div>
  );
};

export default ProfileFacility;
